export const LOG_PRODUCT_TYPES = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  UPDATE_STATUS: 'UPDATE_STATUS',
  INSERT: 'INSERT',
};
